import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { jobsEndpoint } from '../constants';
import LocIcon from "../assets/icons/locIcon.svg";
import BagIcon from "../assets/icons/bagIcon.svg";
import TimeIcon from "../assets/icons/timeicon.svg";
import Avatar from "../assets/Avatar7.png";
import Avatar2 from "../assets/Avatar2.png";
import Avatar3 from "../assets/Avatar3.png";
import GoogleIcon from "../assets/google.png";

function EditJob() {
  const [page, setPage] = useState("jobDetails");
  const { id } = useParams();
  const navigate = useNavigate();
  const [jobData, setJobData] = useState(null);
  const token = localStorage.getItem('token');

  const [editableJobData, setEditableJobData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJobDetails = async () => {
      try {
        setLoading(true);
        const response = await fetch(jobsEndpoint + `${id}/details/`,{
          headers: {
            'Authorization': `Token ${token}`,  
          },
        });
        if (!response.ok) {
          throw new Error('Job not found');
        }
        const data = await response.json();
        console.log(data);
        setJobData(data);
        setEditableJobData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    if (id) {
      fetchJobDetails();
    }
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableJobData({ ...editableJobData, [name]: value });
  };

  const handleUpdate = async () => {
    try {
      const response = await fetch(jobsEndpoint + `${id}/update/`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`,

        },
        body: JSON.stringify(editableJobData),
      });
      if (!response.ok) {
        throw new Error('Failed to update job');
      }
      navigate(`/job_details/${id}`);
    } catch (err) {
      setError(err.message);
    }
  };

  const formatSalary = (salary) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
    }).format(salary) + "/annum";
  };

  const getJobTypeColor = (cardType) => {
    const colors = {
      'design': 'bg-[#B2DDFF] border-[#85c9fc] text-blue-500',
      'engineering': 'bg-[#FFE4B2] border-[#FFD085] text-orange-500',
      'marketing': 'bg-[#E4B2FF] border-[#D085FF] text-purple-500',
      'sales': 'bg-[#B2FFE4] border-[#85FFD0] text-green-500',
      'default': 'bg-[#F0F0F0] border-[#D0D0D0] text-gray-500'
    };
    return colors[cardType?.toLowerCase()] || colors.default;
  };

  if (loading) return <div className="flex justify-center items-center h-64"><div className="text-lg text-gray-600">Loading...</div></div>;
  if (error) return <div className="flex justify-center items-center h-64"><div className="text-lg text-red-600">Error: {error}</div></div>;
  if (!jobData) return <div className="flex justify-center items-center h-64"><div className="text-lg text-gray-600">No job data found</div></div>;

  return (
    <div>
      <div className="mb-8">
        <div className="flex justify-between items-center">
          <div>
            <div className="flex items-center gap-4">
              <input type="text" name="title" value={editableJobData.title} onChange={handleInputChange} className="text-2xl font-semibold text-gray-900 border-b-2 border-transparent focus:border-blue-500 outline-none" />
              <span className={`flex gap-2 items-center px-2 py-1 rounded-2xl text-xs font-semibold ${getJobTypeColor(jobData.card_type)}`}>
                <span style={{ width: "7px", height: "7px", backgroundColor: "currentColor", borderRadius: "50%" }}></span>
                {jobData.card_type || 'General'}
              </span>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <button onClick={handleUpdate} className="px-4 py-2 flex items-center cursor-pointer gap-2 text-white bg-[#19bfb7] rounded-lg hover:bg-[#18ada6]">
              Save Changes
            </button>
          </div>
        </div>
        <div className="flex gap-5 items-center my-5">
          <div className="flex gap-1 items-center">
            <img src={LocIcon} alt="Location" />
            <input type="text" name="location" value={editableJobData.location} onChange={handleInputChange} className="text-gray-500 text-sm font-semibold border-b-2 border-transparent focus:border-blue-500 outline-none" />
          </div>
          <div className="flex gap-1 items-center">
            <img src={TimeIcon} alt="Time" />
            <input type="text" name="time" value={editableJobData.time} onChange={handleInputChange} className="text-gray-500 text-sm font-semibold border-b-2 border-transparent focus:border-blue-500 outline-none" />
          </div>
          <div className="flex gap-1 items-center">
            <img src={BagIcon} alt="Level" />
            <input type="text" name="level" value={editableJobData.level} onChange={handleInputChange} className="text-gray-500 text-sm font-semibold border-b-2 border-transparent focus:border-blue-500 outline-none" />
          </div>
        </div>
      </div>

      <div className="flex items-center gap-5">
        <button onClick={() => setPage("jobDetails")} className={`text-gray-700 text-sm font-semibold py-2 px-3 rounded-lg cursor-pointer ${page === "jobDetails" ? "bg-green-100 text-green-600" : ""}`}>
          Job Details
        </button>
      </div>

      <div className="mt-5">
        {page === "jobDetails" && (
          <div>
            <div className="flex items-center gap-8">
              <div className="min-w-[320px] flex flex-1 justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
                  <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
                    <p className="flex-1 text-[#181D27] text-sm font-semibold">Salary Range</p>
                  </div>
                  <div className="flex self-stretch justify-start items-start flex-col gap-5 p-[20px] bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] relative">
                    <input type="text" name="offer_price" value={editableJobData.offer_price} onChange={handleInputChange} className="text-gray-700 text-lg font-semibold border-b-2 border-transparent focus:border-blue-500 outline-none" />
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-6 flex flex-col gap-10">
              <div className="flex flex-col gap-2">
                <h2 className="text-gray-700 font-semibold text-lg">Job Description</h2>
                <textarea name="body" value={editableJobData.body} onChange={handleInputChange} className="text-gray-500 font-medium text-[16px] w-full h-40 border-b-2 border-transparent focus:border-blue-500 outline-none" />
              </div>
              <div className="flex flex-col gap-2">
                <h2 className="text-gray-700 font-semibold text-lg">Requirements</h2>
                <textarea name="requirements" value={editableJobData.requirements} onChange={handleInputChange} className="text-gray-500 font-medium text-[16px] w-full h-40 border-b-2 border-transparent focus:border-blue-500 outline-none" />
              </div>
                            <div className="flex flex-col gap-2">
                <h2 className="text-gray-700 font-semibold text-lg">Benefits</h2>
                <textarea name="other_benefits" value={editableJobData.other_benefits} onChange={handleInputChange} className="text-gray-500 font-medium text-[16px] w-full h-40 border-b-2 border-transparent focus:border-blue-500 outline-none" />
              </div>
                          <div className="flex flex-col gap-2">
                <h2 className="text-gray-700 font-semibold text-lg">Bonus Incentives</h2>
                <textarea name="bonuses_incentives" value={editableJobData.bonuses_incentives} onChange={handleInputChange} className="text-gray-500 font-medium text-[16px] w-full h-40 border-b-2 border-transparent focus:border-blue-500 outline-none" />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default EditJob;
